import "./MainMenuStyle.scss"
import React, {useMemo, useCallback, useContext} from "react";
import { useTranslation } from 'react-i18next';
import {Link, useLocation} from "react-router-dom";
import {Layout, Button, Badge, Tooltip, Typography} from "antd";
import {IMainMenuDecorator} from "@tools/CustomInterfaces";
import { IPageConfig, SinglePageConfig } from "@extension/config/pagesConfig";
import Icons from "@root/hydraExtension/Icons";
import ScrollBar from "@components/ScrollBar";
import useUserRights from "@hooks/useUserRights";
import useNotificationsCount from "@components/notifications/useNotificationsCount";
import {GlobalContext} from "@tools/globalContext";
import defaultSettings from "@resources/defaultSettings";
interface Props {
    config: IPageConfig,
    decorator: IMainMenuDecorator[],
    onClick: (id: string) => void
}

const MainMenu: React.FC<Props> = (props) => {
    const {config, decorator, onClick} = props;
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const {navigatorVisibility} = useUserRights();
    const {version} = useContext(GlobalContext);
    const {getNotificationsCount} = useNotificationsCount({decorator});

    const activePage = useMemo(() => {
        let currentUrl = pathname || "";
        if(process.env.PUBLIC_URL !== "/")
            currentUrl = currentUrl.replace(process.env.PUBLIC_URL, "")
        return currentUrl.split("/")[1]
    }, [pathname])

    const getPageUrl = useCallback((item: SinglePageConfig) => {
        if (item.url?.indexOf("/") === 0)
            return item.url

        return `${config.rootUrl ? `/${config.rootUrl}` : ""}/${item.url || item.id}`
    },[config]);

    const arrangeFields: SinglePageConfig[] = useMemo(() => {
        return decorator.filter(page => navigatorVisibility(page)).reduce((res, item) => {
            if (item.noMenu)
                return res
            const page = config.pages.find(field => field.id === item.id);
            if (page) {
                //@ts-ignore
                res.push(page)
            }
            return res;
        }, [])
    },[config, decorator, navigatorVisibility] )

    const renderBtn = useCallback((item: SinglePageConfig) => {
        const badgeValue = getNotificationsCount(item.id as string); //notifications["order"/*item.id as string*/]
        const iconPath = item.icon || `menu.${item.id}`;
        const menuTextPath = item.text || `menu:${item.id}.title`;

        return <Badge size="small" key={item.id} count={badgeValue} offset={[-12, 15]}>
            <Tooltip placement="right" title={t(menuTextPath)}>
                <Button
                    type={activePage === item.id ? "primary" : "default"}
                    className="mainButton"
                    size="large"
                    shape="circle"
                    icon={Icons(iconPath, {def: true})}
                    onClick={() => onClick(item.id as string)}
                />
            </Tooltip>
        </Badge>

    }, [t, getNotificationsCount, activePage, onClick]);

    return <Layout.Sider {...defaultSettings.mainMenuTheme && {theme: defaultSettings.mainMenuTheme as any}} className="mainMenu">
        <ScrollBar style={{flex: "1 1 auto"}}>
            {(arrangeFields || []).filter((item: SinglePageConfig) => !item.noMenu).map((item: SinglePageConfig) => {
                if (item.noLink)
                    return renderBtn(item);

                const urlPath = getPageUrl(item)
                return <Link key={item.id} to={urlPath} data-test={item.id}>
                    {renderBtn(item)}
                </Link>
            })}
        </ScrollBar>
        <Typography.Text style={{flex: "0 0 auto", color: defaultSettings.mainMenuTheme === "dark" ? "black": "white", textAlign: "center", width: "100%"}}>{version}</Typography.Text>
    </Layout.Sider>
}

export default MainMenu
